<template>
  <div id="alertSnackbar">
    <v-snackbar
      :timeout="alert.timeout"
      :color="alert.color"
      :multi-line="true"
      :vertical="false"
      v-model="alert.enable"
    >
      {{ alert.message }}
      <v-btn text @click.native="alert.enable = false">close</v-btn>

      <!-- 아래쪽 div는 snackbar 클릭이 dialog 클로즈되는 것을 막아 준다 -->
      <!-- @see https://stackoverflow.com/questions/49627750/vuetify-closing-snackbar-without-closing-dialog -->
      <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    name: 'alertSnackbar',
    data() {
      return {
        alert: {
          enable: false,
          timeout: 3000,
          color: 'red',
          message: 'default message'
        }
      }
    },
    methods: {
      printDebugLog(target) {
        console.dir(target);
      },
      receiveAlert(receivedAlert) {
        this.alert.color = receivedAlert.color;
        this.alert.message = receivedAlert.message;
        this.alert.enable = true;
      }
    },
    mounted() {
      this.$bus.$on('popupAlert', this.receiveAlert);
    }
  }
</script>